import { render } from "./conect-student.vue?vue&type=template&id=61a3f23b"
import script from "./conect-student.js?vue&type=script&lang=js&external"
export * from "./conect-student.js?vue&type=script&lang=js&external"

import "./conect-student.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__